import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dateFormat from 'dateformat'
import { toast } from 'react-toastify'
import { fetchFileDocument } from '../../../utilities/API/document/documentAPI'

export const fetchAppFileDoc = createAsyncThunk(
    'appDoc', fetchFileDocument
)


const initialState = {
    isDownloaded:false,
    docList:[],
    corrList:{}
}

const documentDownloadSlice = createSlice({
    name: 'documentDownload',
    initialState,
    reducers: {

        resetApplicationsDocLists: (state) => {
            state.corrList={};
            state.docList=[];
            state.isDownloaded = false;
            // toast.success("Applictions reseted Successfully")
        },
        resetIsDownloaded:(state) =>{
          state.isDownloaded=false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppFileDoc.pending, (state, action) => {
                // toast.warn("applications list pending")
            })
            .addCase(fetchAppFileDoc.fulfilled, (state, action) => {
                state.isDownloaded = true
                let data = action.payload.res;
                let filetype ;
              
                let UploadFilename =  data.FileName.split(".");
                switch(UploadFilename[1]) {
                 case "pdf":
                   filetype = "application/pdf";
                   break;
                 case "png":
                     case "PNG":
                   filetype = "image/png";
                   break;
                 case "jpeg":
                      filetype = "image/jpeg";
                   break;
                 case "docx":
                 filetype = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                   break;
                 case "doc":
                 filetype = "application/msword";
                   break;
                 case "csv":
                 filetype = "text/csv";
                   break;
               }
            
            
           if (navigator.msSaveBlob) {
              
             let filety = `${filetype};base64` ;
             let ty  = filetype;
             const byteCharacters = atob(data.FileData);
             const byteNumbers = new Array(byteCharacters.length);
             for (let i = 0; i < byteCharacters.length; i++) {
                 byteNumbers[i] = byteCharacters.charCodeAt(i);
             }
             var blob = new Blob([new Uint8Array(byteNumbers)], {type:filety});
             navigator.msSaveBlob(blob, data.FileName);
           }
         else{
           
               const linkSource = `data:${filetype};base64,${data.FileData}`;
                
               const downloadLink = document.createElement("a");
               const fileName = data.FileName;
               
               downloadLink.href = linkSource;
               downloadLink.download = fileName;
               downloadLink.click();
         }
               
            })
            .addCase(fetchAppFileDoc.rejected, (state, action) => {
                // toast.error(action.error.message)
            })




    },
})

export const { resetApplicationsDocLists, resetIsDownloaded } = documentDownloadSlice.actions

export default documentDownloadSlice.reducer